export const urlToApi = (url: string) => {
  return `${process.env.REACT_APP_API_BASE_URL}${url}`;
};
